import { defineComponent as o, openBlock as n, createBlock as c, unref as r, mergeProps as m, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ o({
  name: "IconLightbulb",
  __name: "IconLightbulb",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const l = t;
    return (u, e) => (n(), c(r(i), m(l, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", { d: "M12.75 3.25a.75.75 0 0 0-1.5 0v1.414a.75.75 0 0 0 1.5 0V3.25M4.97 5.22a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m14.06 1.06a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1M5.164 11.25A.75.75 0 0 1 4.414 12H3a.75.75 0 0 1 0-1.5h1.414a.75.75 0 0 1 .75.75m16.586 0A.75.75 0 0 1 21 12h-1.414a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M6.25 12.101C6.199 8.501 9.192 6.5 12 6.5c2.822 0 5.75 2.009 5.75 5.59v.011c-.022 1.504-.498 2.573-1.455 3.585a24 24 0 0 1-.364.374 4 4 0 0 0-.424.474c-.115.164-.205.358-.24.78a1 1 0 0 1-.017.12v1.816A2.25 2.25 0 0 1 13 21.5h-2a2.25 2.25 0 0 1-2.25-2.25v-1.814a1 1 0 0 1-.016-.122c-.036-.422-.126-.616-.241-.78a4 4 0 0 0-.425-.475 17 17 0 0 1-.362-.373c-.958-1.011-1.433-2.081-1.455-3.585m4 6.399h3.5v.75A.75.75 0 0 1 13 20h-2a.75.75 0 0 1-.75-.75V18.5m4.031-2.83c-.265.376-.422.786-.49 1.33h-3.582c-.069-.544-.225-.954-.49-1.33-.182-.26-.434-.515-.676-.761l-.248-.255c-.709-.748-1.028-1.462-1.044-2.575C7.713 9.519 9.81 8 12 8c2.176 0 4.246 1.51 4.249 4.085-.017 1.11-.337 1.822-1.044 2.57l-.249.255c-.242.245-.493.501-.676.76",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
